import * as _ from "lodash";
import * as React from "react";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import { FoodGroup } from "../utils/AppConstants";
import AppUtils from "../utils/AppUtils";
import CustomSelect from "./CustomSelect";
import TextInput from "./TextInput";
import { TypeAheadElement } from "./TypeAhead";

export interface SingleFoodGroupItemProps {
    callbackMeta: number;
    staticFoodGroups: IStaticDataValue[];
    selectedFoodGroups: string[];
    themeValue: number;
    onThemeLabelSelect: (label: string, index: number) => void;
    onCategoryValueChange: (value: number, index: number) => void;
    onRemove: (index: number) => void;
}

export interface SingleFoodGroupItemState {
    text: string;
}

class SingleFoodGroupItem extends React.PureComponent<SingleFoodGroupItemProps, SingleFoodGroupItemState> {
    constructor(props: SingleFoodGroupItemProps) {
        super(props);
        let text = AppUtils.getFoodGroupsIdFromList(props.selectedFoodGroups);
        this.state = {
            text: !_.isEmpty(text) ? FoodGroup[text] : ""
        }
    }
    onThemeLabelChange = (input: string) => {
        this.setState({
            text: input
        });
        let themeTypeAheadOptions: TypeAheadElement[] = [];
        _.map(FoodGroup, (foodGroup, key) => {
            if (foodGroup.toLowerCase().indexOf(input.toLowerCase()) !== -1) {
                themeTypeAheadOptions.push({
                    value: key,
                    label: foodGroup
                })
            }
        })
        return Promise.resolve({options: themeTypeAheadOptions, completed: true});
    }
    onThemeTypeAheadSelect = (elem: TypeAheadElement) => {
        this.setState({
            text: FoodGroup[elem.value]
        }, () => {
            this.props.onThemeLabelSelect(elem.value, this.props.callbackMeta);
        })
    }
    onFoodGroupSelect = (value: string) => {
        if (!_.isEmpty(value)) this.props.onThemeLabelSelect(value, this.props.callbackMeta);
        // else this.removeFoodGroup();
    }
    onDistributionChange = (evt: any) => {
        let input = evt.target.value;
        let value = parseInt(input);
        if (input === "" || !isNaN(value)) {
            let valueToPass = input !== "" ? value : "";
            this.props.onCategoryValueChange(valueToPass, this.props.callbackMeta);
        }
    }
    removeFoodGroup = () => {
        this.props.onRemove(this.props.callbackMeta);
    }
    render() {
        let themeLabel = this.state.text;
        let selectedValue = AppUtils.getFoodGroupsIdFromList(this.props.selectedFoodGroups);
        return (
            <div className={"food-group-single-item-container"}>
                <span className={"cancel-theme"}><span className={"glyphicon glyphicon-remove"} onClick={this.removeFoodGroup} /></span>
                <div className={"label-container"}>
                    <CustomSelect dropdownValues={this.props.staticFoodGroups} selectedValue={FoodGroup[selectedValue]} defaultValue={"Select"} updateDropdownValue={this.onFoodGroupSelect}/>
                    {/* <TypeAhead widgetName={"SingleFoodGroupItem"} name={"food-group-label-selector"} value={themeLabel} placeholder={"Start typing food group name"} onTypeAheadChange={this.onThemeLabelChange} onTypeAheadSelect={this.onThemeTypeAheadSelect}/> */}
                </div>
                <TextInput disabled={_.isEmpty(this.props.selectedFoodGroups)} value={this.props.themeValue} name={`food-group-item-${this.props.callbackMeta}`} onChange={this.onDistributionChange}/>
                <span className={"percentage-label"}>%</span>
            </div>
        )
    }
}

export default SingleFoodGroupItem;